import { type FC, memo, useCallback } from "react";
import { Heading, Text } from "@stubhub/broadway-web";
import { BarcodeScanIcon, FanProtectOutlineIcon, TicketsOutlineIcon } from "@stubhub/broadway-web/icons/functional";
import { Content, FormatContent } from "src/shared/components/content";
import { PE_KEYS } from "src/shared/constants/PageEventKeys";
import { PE_TYPE } from "src/shared/constants/PageEventTypes";
import { useStorePageEvent } from "src/shared/hooks/useStorePageEvent";
import { useIsStubhub } from "src/shared/utils/appContextHelper";
import {
  FAN_PROTECT_TRADEMARK,
  VIAGOGO_BRAND_NAME,
} from "src/website-apps/shared/components/brand-guarantee/constants";
import { InViewTracker } from "src/website-apps/shared/components/InViewTracker";
import { contentIds } from "./contentIds";
import { trustCardRecipe, trustCardRowText } from "./styles";
import { useTrustCardContent } from "./useTrustCardContent";

export const TrustCard: FC = memo(() => {
  const storePageEvent = useStorePageEvent();
  const isStubhub = useIsStubhub();
  const { heading } = useTrustCardContent();
  const styles = trustCardRecipe();

  const handleModuleView = useCallback(() => {
    storePageEvent(PE_TYPE.LOGGING, PE_KEYS.TRUST_CARD_MODULE_VIEW, "desktop");
  }, [storePageEvent]);

  if (!heading) {
    return null;
  }

  return (
    <div className={styles.card}>
      <InViewTracker onInView={handleModuleView} />
      <Heading variant="header" size="small" as="h2">
        {heading}
      </Heading>
      <div className={styles.rows}>
        <div className={styles.row}>
          <div className={styles.icon}>
            <TicketsOutlineIcon size={24} />
          </div>
          <div className={trustCardRowText}>
            <Text variant="body" size="medium">
              <Content id={contentIds.ticketsSold} />
            </Text>
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.icon}>
            <BarcodeScanIcon size={24} />
          </div>
          <div className={trustCardRowText}>
            <Text variant="body" size="medium">
              <Content id={contentIds.validAndOnTime} />
            </Text>
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.icon}>
            <FanProtectOutlineIcon size={24} />
          </div>
          <div className={trustCardRowText}>
            <Text variant="body" size="medium">
              <FormatContent
                id={contentIds.protection}
                params={isStubhub ? FAN_PROTECT_TRADEMARK : VIAGOGO_BRAND_NAME}
                raw
              />
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
});

TrustCard.displayName = "TrustCard";
